import styled from 'styled-components';

export const MessagePopupContainer = styled.div`
  box-sizing: border-box;
  width: 400px;
  padding: 24px;
  background: white;
  box-shadow: 0px 20px 24px -4px rgba(16, 24, 40, 0.08),
    0px 8px 8px -4px rgba(16, 24, 40, 0.03);
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .successIcon {
    color: ${({ tema }) => tema?.primaryColor ?? '#1D3054'};
  }

  .title {
    margin-top: 20px;
    font-size: 20px;
    line-height: 28px;
    text-align: ${({ txtAlign }) => txtAlign ?? 'center'};
    color: ${({ isError, tema }) =>
      isError ? '#b91c1c' : tema?.primaryColor ?? '#1D3054'};
    font-weight: bold;
  }

  .title-with-close {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 24px;
    line-height: 32px;
    color: ${({ tema }) => tema?.primaryColor ?? '#1D3054'};
    font-weight: bold;
    margin-bottom: 10px;
  }

  .message {
    line-height: 24px;
    font-size: 16px;
    text-align: ${({ txtAlign }) => txtAlign ?? 'center'};
    margin-bottom: 32px;
    color: #4d4d4d;
  }

  .container-buttons {
    width: 100%;
    display: flex;
    gap: 12px;
    flex-direction: ${({ containerButtonsDirection }) =>
      containerButtonsDirection ?? 'row'};
  }

  @media (max-width: 768px) {
    width: 350px;
    .container-buttons {
      flex-direction: column-reverse;
    }
  }
`;

export const PageOverlay = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;
  background-color: rgba(0, 0, 0, 0.4);

  > div {
    pointer-events: none;

    div {
      pointer-events: all;
    }
  }
`;
